export default function findColorById(categories, id) {
  let matchedColor = null;
  if (categories) {
    Object.values(categories).forEach((category) => {
      category.colors.forEach((color) => {
        if (color.id === id) {
          matchedColor = { ...color };
        }
      });
    });
  }
  return matchedColor;
}
